import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import ConsentGate from "./ConsentGate";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, consent } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A1628] text-[#D4AF37] font-display text-xl">
        Memuat...
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (!consent) return <ConsentGate />;
  if (adminOnly && user.role !== "administrator") return <Navigate to="/dashboard" replace />;
  return children;
}
